
  
<swiper class="swiper-container" [config]="config">
    <div *ngFor="let slide of slides" class="swiper-slide">
      <div style="height:100%;">
        <img src="{{slide.url}}" style="height:100%;width:100% !important">
      </div>
    </div>
  </swiper>